import * as React from 'react';
import * as autoBind from 'react-autobind';
import * as moment from 'moment';
import {InlineLabeledRadio, ControlButton, Glyphs, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';
import ReviewVersionModel from '../../types/ReviewVersionModel';
import ReviewRouterService from '../../services/ReviewRouterService/ReviewRouterService';
import ReviewModel from '../../types/ReviewModel';
import Store from '../../redux/Store';
import {ButtonActivationKeys} from '../../globals/Constants';
import {RouteComponentProps} from 'react-router';

export default class VersionInfoRow extends React.Component<VersionInfoRowProps, VersionInfoRowState> {
   readonly state: VersionInfoRowState = {saving: false, showAlert: false};

   constructor(props: VersionInfoRowProps) {
      super(props);
      autoBind(this);
   }

   onSelectVersion(e: any): void {
      const {history, review, reviewVersion} = this.props;

      e.preventDefault();
      if (!(e.target.dataset.testId === 'delete-version-button')) {
         history.push(ReviewRouterService.createCanonicalReviewUrl(review.Id, reviewVersion.VersionNumber));
      }
   }

   onDeleteVersion(e: any) {
      const {reviewVersion, deleteVersion} = this.props;
      deleteVersion(reviewVersion);
   }

   onKeyPress(e: any): void {
      if (e.keyCode in ButtonActivationKeys && !e.shiftKey) {
         this.onSelectVersion(e);
      }
   }

   render() {
      const {isSelected, reviewVersion} = this.props;
      const radialButtonLabel = Strings.accessibility.versionInfoRowRadialButtonLabel.replace('{param0}', reviewVersion.VersionNumber.toString());
      const thumbnailAltText = Strings.accessibility.versionInfoRowThumbnailAltText.replace('{param0}', reviewVersion.VersionNumber.toString());

      return (
         <div className="version-info-row-container" onClick={this.onSelectVersion} onKeyDown={this.onKeyPress} tabIndex={0} aria-label={Strings.labels.versions.versionFull.replace('{param0}', reviewVersion.VersionNumber.toString())}>
            <span className="version-info-row-radio" tabIndex={-1}>
            <InlineLabeledRadio isSelected={isSelected} label={radialButtonLabel} onChange={this.onSelectVersion} isLabelHidden={true}/>
            </span>
            <span className="version-info-row-thumbnail-container">
            <img className="version-info-row-thumbnail" alt={thumbnailAltText} {...(reviewVersion.ThumbnailUrl ? {src: reviewVersion.ThumbnailUrl} : {})} />
            </span>
            <div className="version-info-row-data">
               <div className="version-info-row-version">{Strings.labels.versions.versionFull.replace('{param0}', reviewVersion.VersionNumber.toString())}</div>
               <div className="version-info-row-date">{moment(reviewVersion.CreatedDate).fromNow().toString()}</div>
            </div>
            {reviewVersion.VersionNumber !== 1 && Store.getState().isOwner && <div className="delete-version">
               <ControlButton buttonType={TscButtonType.tertiary} glyph={<Glyphs.Delete16x16/>} testId="delete-version-button" onClick={this.onDeleteVersion} title={Strings.labels.versions.deleteVersion}/>
            </div>}
         </div>
      );
   }
}

export interface VersionInfoRowProps extends RouteComponentProps {
   isSelected: boolean;
   reviewVersion: ReviewVersionModel;
   review: ReviewModel;
   currentReviewVersion: ReviewVersionModel;
   deleteVersion(version: ReviewVersionModel): void;
}

export interface VersionInfoRowState {
   showAlert: boolean;
   saving: boolean;
}
